// extracted by mini-css-extract-plugin
export default {"cursorPresence":"cursor-presence__YKzfwZVP","cursor":"cursor__ZgbSLlP2","cursorName":"cursor-name__WwZgZ6KM"};